import React from 'react'
import { Link } from 'react-router-dom'
import BeatLoader from 'react-spinners/BeatLoader'
import ProbeListHelp from '../help/ProbeListHelp'
import buildQuery from '../../helpers/buildQuery'

import { DonutCharts } from '@stem-sims/great-leaps-react-common'

function Header({studentCode, student, customer, active, story = null, suggestedStory, loading, sectionClick = () => {}})
{
    if (active !== "phonics" && active !== "phrases" && active !== "stories")
        throw "Header's active type must be one of the following: phonics, phrases, stories"
    
    const standardVariables = buildQuery({ student: student, customer: customer })
    return (
        <React.Fragment>
            <h1 class = "break-words">Start an Exercise with {student}
                <ProbeListHelp />
            </h1>
            {loading ? 
            <div style={{ margin: "0 auto", display: "table", height: "16vh"}}>
                <div style={{ display: "table-cell", verticalAlign: "middle", textAlign: "center"}}>
                    <BeatLoader
                        size={15}
                        color={"#123abc"}
                        loading={true}
                        />
                </div>
            </div>
            
            : <DonutCharts customer={customer} student={student} /> }

            <div class = "row">
                <Link to = {`/students/records/${active}${story ? "/" + story : ""}?${standardVariables}`}
                        target = "_blank"
                        className = "btn btn-secondary btn-lg ml-auto mr-auto pr-5 pl-5 mb-4" style={{ width: 'fit-content' }}>
                            <span class="hidden-xxs d-none d-sm-inline">View</span> Records
                </Link>
            </div>

            <h2 class = "subheader-text">Student Code: <span class = "readable">{studentCode}</span></h2>

            <div class = "row subheader-text">
                <div class = "col-12 col-md-4">
                    <Link to = {`/probes/phonics?${standardVariables}`} class = {`btn btn-secondary btn-lg ${active === "phonics" ? "active" : ""}`} onClick={sectionClick}>Phonics</Link>
                </div>

                <div class = "col-12 col-md-4">
                    <Link to = {`/probes/phrases?${standardVariables}`} class = {`btn btn-secondary btn-lg ${active === "phrases" ? "active" : ""}`} onClick={sectionClick}>Phrases</Link>
                </div>

                <div class = "col-12 col-sm-6 offset-sm-3 col-md-4 offset-md-0">
                    <Link to = {`/probes/stories/${suggestedStory}?${standardVariables}`} class = {`btn btn-secondary btn-lg ${active === "stories" ? "active" : ""}`} onClick={sectionClick}>Stories</Link>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Header
